import { TransformInt } from '../../../decorators/transform-int.decorator';
import { FileRecordCategoryEnum } from '../enums/file-record-category.enum';
import { FileSensitivityEnum } from '../enums/file-sensitivity.enum';

/**
 * File DTO
 */
export class FileDto {
	@TransformInt()
	id?: number;
	uuid!: string;
	name!: string;
	@TransformInt()
	size!: number;
	mimeType!: string;
	sensitivity!: FileSensitivityEnum;
	recordCategory!: FileRecordCategoryEnum;
	isFavorite!: boolean;
}
